<div class="db-enable-tax-calc" [ngClass]="{'blured': website?.isAiBuilderDemo}">
  <div class="db-enable-tax-calc__header">
    <h1>{{ 'text_enableTaxRatesAndCalculations' | dbText }}</h1>
    <div class="mt4">
      <p [innerHTML]="'text_chooseToIncludeOrExcludeTaxesFromPrices' | dbText"></p>
      <button class="ds-btn-black rectangle"
              (click)="enableCalcTaxes()"
              [ngClass]="{'ds-btn-disabled': !!loading}">
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        <span *ngIf="!loading">{{ 'text_activate' | dbText }}</span>
      </button>
    </div>
  </div>

  <div class="db-enable-tax-calc__content blured mt30">
    <div class="db-search-wrap">
      <ds-search-input [width]="'260px'" [formControl]="searchTerm" [hasSearchIcon]="true" [placeholder]="'text_searchEllipsis' | dbText"></ds-search-input>
    </div>
    <div class="ds-input-wrap static">
      <ds-dropdown [dsDropdownOptions]="fakeOptions"
                   [dsDropdownWidth]="'180px'"
                   [dsDropdownPlaceHolder]="'text_filter' | dbText"></ds-dropdown>
      <ds-dropdown [dsDropdownOptions]="fakeAddRatesOptions"
                   [color]="'black'"  [dsDropdownWidth]="'180px'"
                   [dsDropdownPlaceHolder]="'text_addRates' | dbText"></ds-dropdown>
    </div>
  </div>

  <div class="table mt20" >
    <div class="row header-row blured">
      <div class="cell">{{ 'text_rateType' | dbText }}</div>
      <div class="cell">{{ 'text_countryCode' | dbText }}</div>
      <div class="cell">{{ 'text_stateCode' | dbText }}</div>
      <div class="cell">{{ 'text_postcodeZip' | dbText }}</div>
      <div class="cell">{{ 'text_city' | dbText }}</div>
      <div class="cell">{{ 'text_rate' | dbText }}</div>
      <div class="cell">{{ 'text_taxName' | dbText }}</div>
      <div class="cell">{{ 'text_priority' | dbText }}</div>
      <div class="cell">{{ 'text_compound' | dbText }}</div>
      <div class="cell">{{ 'text_shipping' | dbText }}</div>
    </div>
    <div class="row blured">
      <div class="cell">Standard</div>
      <div class="cell">00</div>
      <div class="cell">00000</div>
      <div class="cell">00000</div>
      <div class="cell">Yerevan</div>
      <div class="cell">20%</div>
      <div class="cell">Tax</div>
      <div class="cell">1</div>
    </div>

    <div class="row blured">
      <div class="cell">Reduced</div>
      <div class="cell">00</div>
      <div class="cell">00000</div>
      <div class="cell">00000</div>
      <div class="cell">Yerevan</div>
      <div class="cell">20%</div>
      <div class="cell">Tax</div>
      <div class="cell">1</div>
    </div>

    <div class="row blured">
      <div class="cell">Zero</div>
      <div class="cell">00</div>
      <div class="cell">00000</div>
      <div class="cell">00000</div>
      <div class="cell">Yerevan</div>
      <div class="cell">20%</div>
      <div class="cell">Tax</div>
      <div class="cell">1</div>
    </div>

    <div class="row blured">
      <div class="cell">Zero</div>
      <div class="cell">00</div>
      <div class="cell">00000</div>
      <div class="cell">00000</div>
      <div class="cell">Yerevan</div>
      <div class="cell">20%</div>
      <div class="cell">Tax</div>
      <div class="cell">1</div>
    </div>

    <div class="row blured">
      <div class="cell">Zero</div>
      <div class="cell">00</div>
      <div class="cell">00000</div>
      <div class="cell">00000</div>
      <div class="cell">Yerevan</div>
      <div class="cell">20%</div>
      <div class="cell">Tax</div>
      <div class="cell">1</div>
    </div>
  </div>
</div>
<db-loading-screen *ngIf="!!loadingScreen"></db-loading-screen>
